<div class="create-module__header-container">
  <dcc-page-title class="create-module__header-container__header"
                  title=" {{ pageTitle }}"></dcc-page-title>
  <div type="button"
       class="create-module__header-container__close"
       (click)="close()">
    <i class="lx-icon lx-close-x"></i>
  </div>
</div>

<div class="create-module__input-container">

  <div class="create-module__input">
    <div class="lx-label">Module Name
      <span class="lx-validation-warning" *ngIf="isUpdate === false"> *</span>
    </div>
    <div *ngIf="isUpdate === false">
      <div class="create-module__input-container__name">
        <textarea [(ngModel)]="moduleName"
                  name="moduleName"
                  id="moduleName"
                  placeholder="Enter Module Name">
        </textarea>
      </div>
    </div>
    <div *ngIf="isUpdate === true">
      <div class="create-module__input-container__name">
        <div class="lx-label-bold">
          {{ moduleName }}
        </div>
      </div>
    </div>
  </div>

  <div class="create-module__input">
    <div class="lx-label">Module Description
      <span class="lx-validation-warning">*</span>
    </div>
    <div class="create-module__input-container__description">
      <textarea [(ngModel)]="moduleDescription"
                name="moduleDescription"
                id="moduleDescription"
                placeholder="Enter Module Description (e.g. how will the feature benefit customers)">
      </textarea>
    </div>
  </div>

  <div class="create-module__input">
    <div class="lx-label">Select Icon
      <span class="lx-validation-warning"> *</span>
    </div>
    <div class="create-module__icon-grid">
      <i *ngFor="let icon of icons; let i = index"
         class="icon {{icon}}"
         (click)="onSelectIcon($event, i)"
         [ngClass]="{'icon__active': isActive[i]}"></i>
    </div>
  </div>
</div>

<div class="create-module__footer">
  <div>
    <button class="create-module__footer__close lx-btn lx-btn-secondary"
            (click)="close()">Cancel</button>
    <button class="lx-btn lx-btn-primary"
            (click)="isUpdate === true ? update() : create()">
      {{ isUpdate ? 'Save' : 'Create' }}
    </button>
  </div>
</div>
